import React from 'react'
import Eligibilityhero from '../Eligibilityhero/Eligibilityhero'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Solution from '../Solutions/Solutions'

const Eligibility = () => {
  return (
    <div>
        <Header />
        <Eligibilityhero />
        <Solution />
        <Footer />
    </div>
  )
}

export default Eligibility